var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import { EMPTY } from "rxjs";
import { catchError, delay, filter, map, switchMap, tap } from "rxjs/operators";
import { mockLoginRequest, mockRegisterRequest } from "../../__mock__/mockAuth";
import { IdPersistence } from "../../constants/IdPersistence";
import { CommandCode, StatusCode, } from "../../utils/network/generated/protoTypes";
import { PersistenceMode } from "../../utils/PersistenceMode";
import { utilTracking } from "../../utils/tracking/utilTracking";
import { utilEnvironment } from "../../utils/utilEnvironment";
import { utilPersistence } from "../../utils/utilPersistence";
import { DeviceType } from "../game-tracking/types/DeviceTypeEnum";
import { PlatformType } from "../game-tracking/types/PlatformTypeEnum";
import { landingPageMessageHandler } from "../landing-page/landingPageMessageHandler";
import { actionAuthLogin } from "./actionAuth";
var gameClientCredentials;
var loginFlow = function (props, deps) {
    return deps.netSend({
        id: CommandCode.Login,
        props: props,
    });
};
var registerFlow = function (deps) {
    return deps
        .netSend({
        id: CommandCode.Register,
        props: mockRegisterRequest,
    })
        .pipe(delay(300));
};
export var createEpicAuth = function (triggerActionFilter) { return function (action$, state$, deps) {
    return action$.pipe(filter(triggerActionFilter), switchMap(function () {
        gameClientCredentials = getCredentials();
        if (gameClientCredentials !== undefined &&
            gameClientCredentials.playerId !== undefined) {
            return loginFlow(gameClientCredentials, deps);
        }
        return registerFlow(deps);
    }), catchError(function (error) {
        var status = StatusCode[error.message];
        if (status === StatusCode.ACCESS_DENIED || status === StatusCode.ACCESS_TOKEN_ERROR) {
            landingPageMessageHandler.onLogout();
        }
        return EMPTY;
    }), tap(function (res) {
        gameClientCredentials = getCredentials();
        var gameClientTestCredentials = __assign({}, gameClientCredentials, { deviceId: gameClientCredentials.deviceId
                ? gameClientCredentials.deviceId
                : mockRegisterRequest.clientId, playerId: res.playerId });
        if (utilEnvironment.isDevelopment()) {
            utilPersistence.setValue(IdPersistence.TestCredentials, gameClientTestCredentials, PersistenceMode.Write);
        }
    }), map(function (res) { return actionAuthLogin(res.playerId, res.authToken); }));
}; };
var getCredentials = function () {
    var landingPageCredentials = utilPersistence.getValue(IdPersistence.Credentials, {});
    var isLandingPageCredentialsSet = Object.keys(landingPageCredentials).length !== 0;
    var credentials;
    if (utilEnvironment.isDevelopment() && !isLandingPageCredentialsSet) {
        credentials = utilPersistence.getValue(IdPersistence.TestCredentials, {});
        credentials.clientVersion = mockLoginRequest.clientVersion;
        credentials.deviceType = DeviceType.DESKTOP;
        credentials.platformType = PlatformType.WEB;
        credentials.trackingId = mockLoginRequest.trackingId;
    }
    else {
        credentials = {
            authToken: landingPageCredentials.loginToken,
            clientVersion: mockLoginRequest.clientVersion,
            deviceType: DeviceType.DESKTOP,
            platformType: PlatformType.WEB,
            playerId: Long.fromValue(landingPageCredentials.playerId),
            trackingId: utilTracking.getAccountHash(),
        };
    }
    return credentials;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/auth/createEpicAuth.ts
// module id = 1782
// module chunks = 3